/* eslint-disable react/button-has-type */
// Components
import Button from "components/atoms/Button";
import Timer from "components/atoms/Timer";

// Constants
import { welcomeBonusText } from "constants/bonus";

// Hooks
import useTranslate from "hooks/useTranslate";

// Images
import WelcomeBonus from "assets/images/glory/welcome_bonus_card.webp";
import WelcomeBonusBanger from "assets/images/banger/welcome_banner.webp";
import useFormatNumber from "../../../hooks/useFormatNumber";

// Types
import { BonusType } from "../../../types/info";

import "./styles.sass";

type WelcomeBonusCardFrontProps = {
  expireDate: string;
  isActive: boolean;
  getBonus: () => void;
  onClick: () => void;
  bonusData: BonusType;
};

const WelcomeBonusCardFront = (props: WelcomeBonusCardFrontProps) => {
  const { expireDate, isActive, bonusData, getBonus, onClick } = props;
  const { min } = bonusData;
  const t = useTranslate();
  const { VITE_APP_PROJECT_NAME } = import.meta.env;
  const formatNumber = useFormatNumber();

  const bonusAmount = isActive
    ? welcomeBonusText.bonusReward
    : welcomeBonusText.reward;

  const img =
    VITE_APP_PROJECT_NAME === "banger" ? WelcomeBonusBanger : WelcomeBonus;

  return (
    <div className="WelcomeBonusCardFront">
      <div className="WelcomeBonusCardFront-header">
        {t("bonus.welcome.card.name")}
        <button
          className="WelcomeBonusCardFront-header__description"
          // eslint-disable-next-line react/jsx-handler-names
          onClick={onClick}
        >
          info
        </button>
      </div>
      <div className="WelcomeBonusCardFront-block">
        <div className="WelcomeBonusCardFront-block-info">
          <img
            className="WelcomeBonusCardFront-block-info__img"
            src={img}
            alt="welcome-bonus"
          />
          <div className="WelcomeBonusCardFront-block-info-content">
            <div className="WelcomeBonusCardFront-block-info-content-title">
              <span className="WelcomeBonusCardFront-block-info-content-title__bonus">
                {bonusAmount}
              </span>
              &nbsp;
              <span className="WelcomeBonusCardFront-block-info-content-title__spins">
                {welcomeBonusText.spinsReward}
              </span>
            </div>
            <div className="WelcomeBonusCardFront-block-info-content__description">
              <span>{t("bonus.welcome.card.deposit.from")}</span>
              <span>{formatNumber(min, 0, true)}</span>
            </div>
            {isActive ? (
              <div className="WelcomeBonusCardFront-block-info-content-time">
                <div className="WelcomeBonusCardFront-block-info-content-time__name">
                  {t("bonus.welcome.desc.timer")}
                </div>
                <Timer finishDate={expireDate} isBonus />
              </div>
            ) : null}
          </div>
        </div>
        <div className="WelcomeBonusCardFront-block__controls">
          <Button
            label="bonus.welcome.card.get"
            variation="primary"
            // eslint-disable-next-line react/jsx-handler-names
            onClick={getBonus}
          />
        </div>
      </div>
    </div>
  );
};

export default WelcomeBonusCardFront;
